import axios from '@/lib/axios';
import { PaymentTaskDocument, PurchaseOrderContractTaskDocument } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1070. 支払タスクファイル登録
 * [POST] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/payment_task_documents
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  name: string;
  file?: string;
  url?: string;
};

const createPaymentTaskDocument = (props: Props): Promise<PaymentTaskDocument> => {
  return axios.post(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/payment_task_documents`,
    props
  );
};

export const useCreatePaymentTaskDocument = () => {
  return useMutation({
    mutationFn: createPaymentTaskDocument,
  });
};
